// Sample client data for the application
const clientData = [
    {
        id: 1,
        name: "Sprint Courier Ltd",
        address: {
            street: "123 Transport Way",
            city: "Birmingham",
            postcode: "B12 8HT",
            country: "United Kingdom"
        },
        contact: {
            name: "Jonathan Peters",
            phone: "+44 121 555 7890",
            email: "info@sprintcourier.co.uk"
        },
        policies: [
            {
                policyNumber: "POL-1001",
                startDate: "01/01/2025",
                endDate: "31/12/2025",
                status: "Active",
                vehicles: [
                    {
                        vrn: "AB12 CDE",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["John Smith", "Emma Johnson"]
                    },
                    {
                        vrn: "XY15 ZAB",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["Michael Brown", "Sarah Davis"]
                    }
                ]
            }
        ],
        claims: [
            { claimId: "ABC123", status: "Submitted", date: "21/03/25 10:03", action: "Upload Images" },
            { claimId: "DEF456", status: "Processing", date: "20/03/25 14:22", action: "Await Assessment" }
        ],
        pageUrl: "sprint-courier.html"
    },
    {
        id: 2,
        name: "Value Car Rental UK",
        address: {
            street: "456 Freight Avenue",
            city: "Manchester",
            postcode: "M4 7LP",
            country: "United Kingdom"
        },
        contact: {
            name: "Victoria Adams",
            phone: "+44 161 222 3344",
            email: "info@valuecarental.co.uk"
        },
        policies: [
            {
                policyNumber: "POL-1002",
                startDate: "15/02/2025",
                endDate: "14/02/2026",
                status: "Active",
                vehicles: [
                    {
                        vrn: "CD34 EFG",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["Robert Wilson", "Linda Taylor"]
                    },
                    {
                        vrn: "FG56 HIJ",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["David Miller", "Jennifer Anderson"]
                    }
                ]
            }
        ],
        claims: [
            { claimId: "GHI789", status: "Approved", date: "18/03/25 09:15", action: "Payment Pending" }
        ],
        pageUrl: "value-car.html"
    },
    {
        id: 3,
        name: "Fast-Food Deliveries",
        address: {
            street: "789 Delivery Road",
            city: "Leeds",
            postcode: "LS2 9BT",
            country: "United Kingdom"
        },
        contact: {
            name: "Andrew Thompson",
            phone: "+44 113 333 4455",
            email: "info@fastfooddelivery.co.uk"
        },
        policies: [
            {
                policyNumber: "POL-1003",
                startDate: "10/03/2025",
                endDate: "09/03/2026",
                status: "Active",
                vehicles: [
                    {
                        vrn: "KL78 MNO",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["Thomas Moore", "Patricia White"]
                    },
                    {
                        vrn: "PQ90 RST",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["James Martin", "Elizabeth Clark"]
                    }
                ]
            }
        ],
        claims: [
            { claimId: "JKL012", status: "Completed", date: "17/03/25 11:30", action: "None" }
        ],
        pageUrl: "fast-delivery.html"
    },
    {
        id: 4,
        name: "Auto Driving School",
        address: {
            street: "10 Fleet Street",
            city: "Liverpool",
            postcode: "L3 9QR",
            country: "United Kingdom"
        },
        contact: {
            name: "Sarah Wilson",
            phone: "+44 151 444 5566",
            email: "info@autodrivingschool.co.uk"
        },
        policies: [
            {
                policyNumber: "POL-1004",
                startDate: "05/01/2025",
                endDate: "04/01/2026",
                status: "Active",
                vehicles: [
                    {
                        vrn: "UV12 WXY",
                        coverageType: "Comprehensive",
                        status: "Active",
                        drivers: ["George Robinson", "Susan Lee"]
                    }
                ]
            }
        ],
        claims: [
            { claimId: "978XYZ", status: "Awaiting repair", date: "19/03/25 18:55", action: "ABC123" }
        ],
        pageUrl: "auto-driving.html"
    }
];

// DOM Elements
document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM loaded - initializing application');

    // Detect current page - try multiple methods
    let currentPage = document.documentElement.getAttribute('data-page');

    // If data-page attribute is missing, try to detect from URL and content
    if (!currentPage) {
        currentPage = detectPageTypeFromContent();
        console.log('Detected page type from content:', currentPage);
    }

    console.log('Current page type:', currentPage);

    // Initialize navbar search on all pages
    initNavbarSearch();

    // Initialize based on current page
    if (currentPage === 'fleet-insurance') {
        // Main dashboard page
        console.log('Initializing main dashboard');
        initMainDashboard();
    } else if (currentPage === 'client-page') {
        // Client-specific page
        console.log('Initializing client page');
        initClientPage();
    } else {
        console.log('No specific initialization for this page type, trying client page init as fallback');

        // Check if this might be a client page by looking for common elements
        if (document.querySelector('#clientTabs') ||
            document.querySelector('#policiesTable') ||
            document.querySelector('.breadcrumb-item.active')) {
            console.log('Found client page elements, running client page initialization');
            initClientPage();
        }
    }
});

function detectPageTypeFromContent() {
    // Check for client page indicators
    if (document.querySelector('#clientTabs') ||
        document.querySelector('#policiesTable') ||
        document.querySelector('.breadcrumb-item.active')) {
        return 'client-page';
    }

    // Check for main dashboard indicators
    if (document.querySelector('#summaryCards') ||
        document.querySelector('#claimsTable')) {
        return 'fleet-insurance';
    }

    // Check URL patterns
    const pathname = window.location.pathname.toLowerCase();

    if (pathname.includes('index') || pathname.endsWith('/')) {
        return 'fleet-insurance';
    }

    if (pathname.includes('sprint') ||
        pathname.includes('value') ||
        pathname.includes('auto') ||
        pathname.includes('fast')) {
        return 'client-page';
    }

    return 'unknown';
}

// Initialize navbar search functionality
function initNavbarSearch() {
    console.log('Looking for navbar search element');

    // Try to find the navbar search input with multiple possible selectors
    // This makes it more robust across different page templates
    let navbarSearch = document.querySelector('.content-search input');

    if (!navbarSearch) {
        console.log('First selector failed, trying alternatives');

        // Try additional selectors if the first one failed
        navbarSearch = document.querySelector('nav .form-control');

        if (!navbarSearch) {
            navbarSearch = document.querySelector('header .content-search input');
        }

        if (!navbarSearch) {
            // Last attempt - try to find any search input in the document
            const allSearchInputs = document.querySelectorAll('input[placeholder*="Search"]');
            if (allSearchInputs.length > 0) {
                // Find the one that's not in the content-body (to avoid the table search)
                for (let input of allSearchInputs) {
                    if (!input.closest('.content-body')) {
                        navbarSearch = input;
                        break;
                    }
                }
            }
        }
    }

    // If there's no navbar search input, exit early
    if (!navbarSearch) {
        console.log('Navbar search input not found on this page after trying multiple selectors');
        return;
    }

    console.log('Navbar search found:', navbarSearch);

    // Add ID to navbar search for easier referencing
    navbarSearch.id = 'navbarSearch';

    // Create a dropdown container for search results
    const searchResultsContainer = document.createElement('div');
    searchResultsContainer.id = 'navSearchResults';
    searchResultsContainer.className = 'dropdown-menu dropdown-menu-start position-absolute d-none';
    searchResultsContainer.style.width = 'calc(100% - 2rem)';
    searchResultsContainer.style.zIndex = '1000';
    searchResultsContainer.style.top = '100%';
    searchResultsContainer.style.marginTop = '5px';

    // Make sure the parent container is properly set up
    if (!navbarSearch.parentNode.style.position || navbarSearch.parentNode.style.position === 'static') {
        navbarSearch.parentNode.style.position = 'relative';
    }

    // Insert the dropdown after the search input
    navbarSearch.parentNode.appendChild(searchResultsContainer);

    console.log('Search results container added to the DOM');

    // Add event listeners
    navbarSearch.addEventListener('input', function () {
        console.log('Navbar search input event');
        handleNavbarSearch(this, searchResultsContainer);
    });

    navbarSearch.addEventListener('focus', function () {
        console.log('Navbar search focus event');
        handleNavbarSearch(this, searchResultsContainer);
    });

    navbarSearch.addEventListener('blur', function () {
        console.log('Navbar search blur event');
        // Delay hiding results to allow for clicks
        setTimeout(() => {
            searchResultsContainer.classList.add('d-none');
            searchResultsContainer.classList.remove('show');
        }, 200);
    });
}

// Handle navbar search input
function handleNavbarSearch(inputElement, resultsContainer) {
    const searchTerm = inputElement.value.trim();

    if (searchTerm) {
        const results = filterClients(searchTerm);
        displayNavbarSearchResults(results, resultsContainer);
    } else {
        resultsContainer.classList.add('d-none');
        resultsContainer.classList.remove('show');
    }
}

// Display navbar search results
function displayNavbarSearchResults(results, container) {
    container.innerHTML = '';

    if (results.length === 0) {
        container.classList.add('d-none');
        container.classList.remove('show');
        return;
    }

    // Style the container to match the original glassy black appearance
    container.style.position = 'absolute';
    container.style.backgroundColor = 'rgba(33, 37, 41, 0.95)'; // Dark with slight transparency
    container.style.backdropFilter = 'blur(4px)'; // Glassy effect
    container.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
    container.style.border = '1px solid rgba(255, 255, 255, 0.1)';
    container.style.borderRadius = '4px';
    container.style.maxHeight = '300px';
    container.style.overflowY = 'auto';
    container.style.zIndex = '1050'; // Higher than other elements to ensure visibility

    results.forEach(client => {
        const resultItem = document.createElement('div');
        resultItem.className = 'dropdown-item';
        resultItem.textContent = client.name;
        resultItem.style.cursor = 'pointer';
        resultItem.style.padding = '8px 16px';
        resultItem.style.color = '#fff'; // White text for dark background

        // Hover effect
        resultItem.addEventListener('mouseover', function () {
            this.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        });

        resultItem.addEventListener('mouseout', function () {
            this.style.backgroundColor = 'transparent';
        });

        resultItem.addEventListener('click', function () {
            console.log('Client selected:', client.name, '- navigating to', client.pageUrl);
            // Navigate to client page
            window.location.href = client.pageUrl;
        });

        container.appendChild(resultItem);
    });

    console.log('Showing search results:', results.length, 'clients found');
    container.classList.remove('d-none');
    container.classList.add('show');
}

// Initialize main dashboard functionality
function initMainDashboard() {
    // Table search
    const tableSearch = document.getElementById('tableSearch');
    const claimRows = document.querySelectorAll('#claimsTable tbody tr');

    if (tableSearch) {
        tableSearch.addEventListener('input', function () {
            filterClaimRows(this.value.trim(), claimRows);
        });
    }

    // Initialize table row clicks
    if (document.getElementById('claimsTable')) {
        initTableRowClicks();
    }
}

// Initialize client-specific page functionality
function initClientPage() {
    console.log('Initializing client page');

    // Get client name from page
    const clientName = getClientNameFromPage();
    console.log('Detected client name:', clientName);

    // Try to find client data in the predefined array
    const client = clientData.find(c => c.name === clientName);

    if (client) {
        // If client data found, use it
        console.log('Found client in predefined data:', client.name);
        restructureClientUI(client);
        setupPolicyLinks(client);
    } else {
        // If no client data found, still set up policy links with a fallback approach
        console.log('Client not found in predefined data, using fallback method');
        setupPolicyLinksWithFallback();
    }
}

// Add a new fallback function for setting up policy links when client data is unavailable
function setupPolicyLinksWithFallback() {
    console.log('Setting up policy links with fallback method');

    // Get all policy rows
    const policyRows = document.querySelectorAll('#policiesTable tbody tr');

    if (!policyRows || policyRows.length === 0) {
        console.log('No policy rows found in the table');
        return;
    }

    console.log('Found', policyRows.length, 'policy rows');

    // Process each row
    policyRows.forEach(row => {
        const policyCell = row.querySelector('th');
        if (policyCell) {
            const policyNumber = policyCell.textContent.trim();

            // Style as a link
            policyCell.style.cursor = 'pointer';
            policyCell.style.color = '#ffffff';
            policyCell.style.textDecoration = 'underline';
            policyCell.style.fontSize = '14px';

            console.log('Applied styling to policy cell:', policyNumber);

            // Add click event to navigate to policy details
            policyCell.addEventListener('click', function () {
                console.log('Policy clicked:', policyNumber);

                // Get client name from breadcrumb
                const clientName = document.querySelector('.breadcrumb-item.active')?.textContent.trim() || 'Unknown Client';

                // Create a URL based on policy number
                // Use a naming convention for the policy page URL
                const policyPageUrl = policyNumber.toLowerCase().replace('-', '-') + '.html';

                console.log('Navigating to policy page:', policyPageUrl);

                // Navigate to policy detail page
                // For Sprint Courier with POL-1001, we use sc-pol-1001.html
                if (clientName.includes('Sprint')) {
                    window.location.href = 'sc-pol-1001.html';
                } else if (clientName.includes('Value')) {
                    window.location.href = 'vc-pol-1002.html';
                } else if (clientName.includes('Fast')) {
                    window.location.href = 'ff-pol-1003.html';
                } else if (clientName.includes('Auto')) {
                    window.location.href = 'ad-pol-1004.html';
                } else {
                    // Fallback to a generic pattern
                    window.location.href = 'policy-details.html?policy=' + policyNumber;
                }
            });

            console.log('Added click handler to policy cell');
        }
    });
}

// Get client name from page
function getClientNameFromPage() {
    // Try multiple methods to detect client name

    // 1. Try breadcrumb
    const breadcrumbItems = document.querySelectorAll('.breadcrumb-item');
    for (const item of breadcrumbItems) {
        if (item.classList.contains('active')) {
            console.log('Found client name in breadcrumb:', item.textContent.trim());
            return item.textContent.trim();
        }
    }

    // 2. Try to get from page title
    const titleElement = document.querySelector('.content-header h2, .card-title');
    if (titleElement) {
        const titleText = titleElement.textContent;
        const matches = titleText.match(/Client Dashboard: (.*)/);
        if (matches && matches[1]) {
            console.log('Found client name in title:', matches[1]);
            return matches[1];
        }
    }

    // 3. Try to get from any address element on the page
    const addressElement = document.querySelector('address');
    if (addressElement) {
        const firstLine = addressElement.innerHTML.split('<br>')[0];
        if (firstLine) {
            console.log('Found client name in address:', firstLine);
            return firstLine;
        }
    }

    // 4. Try to get from URL
    const pathname = window.location.pathname.toLowerCase();
    const filename = pathname.substring(pathname.lastIndexOf('/') + 1);

    if (filename.includes('sprint')) return 'Sprint Courier Ltd';
    if (filename.includes('value')) return 'Value Car Rental UK';
    if (filename.includes('fast')) return 'Fast-Food Deliveries';
    if (filename.includes('auto')) return 'Auto Driving School';

    console.log('Could not determine client name from page');
    return null;
}

// Setup "New Claim" button with client data pre-filled
function setupNewClaimButton(client) {
    const newClaimBtn = document.querySelector('.new-claim-btn');

    if (newClaimBtn) {
        newClaimBtn.addEventListener('click', function (e) {
            // Only store client name
            localStorage.setItem('selectedClient', JSON.stringify({
                clientName: client.name
            }));
        });
    }
}

// Filter clients based on search term
function filterClients(searchTerm) {
    if (!searchTerm) return [];

    searchTerm = searchTerm.toLowerCase();
    return clientData.filter(client =>
        client.name.toLowerCase().includes(searchTerm)
    );
}

// Filter claim rows based on search term
function filterClaimRows(searchTerm, rows) {
    if (!rows || rows.length === 0) return;

    if (!searchTerm) {
        // Show all rows if search is empty
        rows.forEach(row => {
            row.style.display = '';
        });
        return;
    }

    searchTerm = searchTerm.toLowerCase();

    rows.forEach(row => {
        // Search in all cells of the row (claim ID, client name, status, etc.)
        const claimId = row.querySelector('th').textContent;
        const clientName = row.getAttribute('data-client') || row.querySelector('td:nth-child(2)')?.textContent;
        const status = row.querySelector('td:nth-child(3) .badge')?.textContent;

        // Check if any of the cells contain the search term
        if (
            (claimId && claimId.toLowerCase().includes(searchTerm)) ||
            (clientName && clientName.toLowerCase().includes(searchTerm)) ||
            (status && status.toLowerCase().includes(searchTerm))
        ) {
            row.style.display = '';
        } else {
            row.style.display = 'none';
        }
    });
}

// Initialize table row click functionality on main dashboard
function initTableRowClicks() {
    const claimRows = document.querySelectorAll('#claimsTable tbody tr');

    claimRows.forEach(row => {
        row.style.cursor = 'pointer';

        row.addEventListener('click', function () {
            const clientName = this.querySelector('td:nth-child(2)')?.textContent;

            if (!clientName) return;

            const client = clientData.find(c => c.name === clientName);

            if (client) {
                // Navigate directly to the client page
                window.location.href = client.pageUrl;
            }
        });
    });
}

// Add this new function for UI restructuring
function restructureClientUI(client) {
    // 1. Remove On Cover and Drivers tabs if they exist
    const onCoverTab = document.querySelector('#cover-tab');
    const driversTab = document.querySelector('#drivers-tab');

    if (onCoverTab) onCoverTab.parentElement.remove();
    if (driversTab) driversTab.parentElement.remove();

    // Remove corresponding tab panes
    const onCoverPane = document.querySelector('#cover');
    const driversPane = document.querySelector('#drivers');

    if (onCoverPane) onCoverPane.remove();
    if (driversPane) driversPane.remove();

    // 2. Add Policy Number column to Claims table if it doesn't exist
    const claimsTable = document.querySelector('#claimsTable');
    if (claimsTable) {
        const headerRow = claimsTable.querySelector('thead tr');
        const firstBodyRow = claimsTable.querySelector('tbody tr');

        // Check if Policy Number column already exists
        if (!headerRow.querySelector('th:nth-child(2)').textContent.includes('Policy')) {
            // Create and insert Policy Number header after Claim ID
            const policyHeader = document.createElement('th');
            policyHeader.textContent = 'Policy Number';
            policyHeader.scope = 'col';
            headerRow.insertBefore(policyHeader, headerRow.children[1]);

            // Add Policy Number cells to each row
            const rows = claimsTable.querySelectorAll('tbody tr');
            rows.forEach(row => {
                const policyCell = document.createElement('td');
                // Use the first policy number from client data for simplicity
                policyCell.textContent = client.policies[0].policyNumber;
                row.insertBefore(policyCell, row.children[1]);
            });
        }
    }

    // 3. Move New Claim button to Claims tab
    const newClaimBtn = document.querySelector('.new-claim-btn');
    const claimsPane = document.querySelector('#claims');

    if (newClaimBtn && claimsPane) {
        // Remove button from its current location
        newClaimBtn.remove();

        // Create header for claims tab with button
        const claimsHeader = document.createElement('div');
        claimsHeader.className = 'd-flex justify-content-between mb-3';
        claimsHeader.innerHTML = `
            <h6 class="mb-0">Active Claims</h6>
            <a href="policy-details.html" class="btn btn-sm btn-secondary new-claim-btn" 
                data-client="${client.name}">
                <i class="ph ph-plus me-2"></i>New Claim
            </a>
        `;

        // Insert at the top of claims pane
        claimsPane.insertBefore(claimsHeader, claimsPane.firstChild);

        // Setup the new button
        setupNewClaimButton(client);
    }
}

// Add this new function for policy links
function setupPolicyLinks(client) {
    console.log('Setting up policy links for client:', client.name);

    // Make policy numbers clickable in Policies tab
    const policyRows = document.querySelectorAll('#policiesTable tbody tr');

    if (!policyRows || policyRows.length === 0) {
        console.log('No policy rows found in the table');
        return;
    }

    console.log('Found', policyRows.length, 'policy rows');

    policyRows.forEach(row => {
        const policyCell = row.querySelector('th');
        if (policyCell) {
            const policyNumber = policyCell.textContent.trim();

            // Style as a link
            policyCell.style.cursor = 'pointer';
            policyCell.style.color = '#ffffff';
            policyCell.style.textDecoration = 'underline';
            policyCell.style.fontSize = '14px';

            console.log('Applied styling to policy cell:', policyNumber);

            // Add click event to navigate to policy details
            policyCell.addEventListener('click', function () {
                console.log('Policy clicked:', policyNumber);

                // Find policy data
                const policyData = client.policies.find(p => p.policyNumber === policyNumber);

                if (policyData) {
                    // Store policy data for the policy detail page
                    localStorage.setItem('selectedPolicy', JSON.stringify({
                        clientName: client.name,
                        policyNumber: policyNumber,
                        policy: policyData
                    }));

                    console.log('Saved policy data to localStorage');
                }

                // Generate URL based on client name and policy number
                let policyPageUrl = 'policy-details.html?policy=' + policyNumber;

                // For Sprint Courier with POL-1001, we use sc-pol-1001.html
                if (client.name.includes('Sprint')) {
                    policyPageUrl = 'sc-pol-1001.html';
                } else if (client.name.includes('Value')) {
                    policyPageUrl = 'vc-pol-1002.html';
                } else if (client.name.includes('Fast')) {
                    policyPageUrl = 'ff-pol-1003.html';
                } else if (client.name.includes('Auto')) {
                    policyPageUrl = 'ad-pol-1004.html';
                }

                console.log('Navigating to policy page:', policyPageUrl);

                // Navigate to policy detail page
                window.location.href = policyPageUrl;
            });

            console.log('Added click handler to policy cell');
        }
    });
}